// removed by extract-text-webpack-plugin
module.exports = {"wrapper":"src-components-project-project-slider-weichert----slider-module---wrapper---1EIcs","container":"src-components-project-project-slider-weichert----slider-module---container---TkomO","imageWrapper":"src-components-project-project-slider-weichert----slider-module---imageWrapper---1CfLs","navWrapper":"src-components-project-project-slider-weichert----slider-module---navWrapper---1t_Nk"};


//////////////////
// WEBPACK FOOTER
// ./src/components/project/project-slider-weichert/slider.module.css
// module id = 533
// module chunks = 140935043865547